export const CHOOSE_TAB = '@@devicesTabs/choose_tab'

export const RESET_DEVICE_TABS = '@@devicesTabs/reset'
